import { render } from "./locations.vue?vue&type=template&id=01a51f91"
import script from "./locations.vue?vue&type=script&setup=true&lang=ts"
export * from "./locations.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "01a51f91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01a51f91', script)) {
    api.reload('01a51f91', script)
  }
  
  module.hot.accept("./locations.vue?vue&type=template&id=01a51f91", () => {
    api.rerender('01a51f91', render)
  })

}

script.__file = "resources/scripts/components/map/locations.vue"

export default script